<div class="section position-relative">
    <div class="section-top">
        <h3 class="section-title">General</h3>
        <div class="section-top-actions">
            <button type="button" class="btn btn-sm btn-warning pull-right ms-1" (click)="clearCache()"
                title="Curățare cache la nivel de sistem/aplicație">
                <i class="fa-solid fa-shield-halved"></i>
            </button>
        </div>
    </div>
    <div class="settings-container p-4">
        <!-- Setări Generale -->
        <div class="settings-section mb-3">
            <h4 class="section-subtitle">Setări Generale</h4>
            <form [formGroup]="generalForm">
                <div class="row">
                    <div class="col-md-3">
                        <mat-form-field appearance="fill" class="w-100">
                            <mat-label>Absențe programări</mat-label>
                            <input matInput type="number" formControlName="absente_programari" min="0">
                        </mat-form-field>
                    </div>
                </div>
                <div
                    *ngIf="generalModified && permissionsService.hasPermission('dgaspc-module.settings.general-settings.update')">
                    <button mat-raised-button color="primary" (click)="updateGeneral()">
                        Actualizare
                    </button>
                </div>
            </form>
        </div>
    </div>
    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>